import { graphql } from '../../gql';

export const COMPOSITION_V4 = graphql(`
  query CompositionV4(
    $req: CompositionV4Req!
    $headcount: Boolean!
    $hiring_rate: Boolean!
    $attrition_rate: Boolean!
    $growth_rate: Boolean!
    $tenure: Boolean!
    $salary: Boolean!
  ) {
    composition_v4(req: $req) {
      entities {
        id
        index
        short_name
        long_name
        metrics {
          headcount @include(if: $headcount) {
            id
            val
          }
          hiring_rate @include(if: $hiring_rate) {
            id
            val
          }
          attrition_rate @include(if: $attrition_rate) {
            id
            val
          }
          growth_rate @include(if: $growth_rate) {
            id
            val
          }
          tenure @include(if: $tenure) {
            id
            val
          }
          salary @include(if: $salary) {
            id
            val
          }
        }
        breakdowns {
          dimension
          level
          categories {
            id
            short_name
            headcount {
              id
              count
              share
            }
          }
        }
      }
    }
  }
`);
